import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=256a5162&scoped=true&"
import script from "./Simulation.vue?vue&type=script&lang=ts&"
export * from "./Simulation.vue?vue&type=script&lang=ts&"
import style0 from "./Simulation.vue?vue&type=style&index=0&id=256a5162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a5162",
  null
  
)

export default component.exports